import { FilterMatchMode } from "primereact/api"

export class Parametro {
    model = {
        id: { value: null, export: false },
        nombre: {
            value: '', export: true, header: 'Nombre', required: 'Nombre es requerido', maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 250, min: 4, table: true, matchMode: FilterMatchMode.CONTAINS,
            filterField: 'nombre', filter: true, sort: true, filterPlaceholder: 'Buscar',
            headerStyle: { width: '15%', minWidth: '15rem' }
        },
        nemonico: {
            value: '', export: true, header: 'Sigla', required: false, maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 50, min: 4, table: true,
        },
        valor: {
            value: '', export: true, header: 'Valor', required: 'Valor es requerido', maxLength: 'Máximo 500 caracteres',
            minLength: 'Mínimo 1 caracteres', max: 500, min: 1, table: true,
        },
        empresa: {
            header: 'Empresa', value: '', required: 'Empresa es requerido', optionLabel: 'empresa', export: true, table: false
        },
        tipo: {
            header: 'Tipo', value: '', required: false, optionLabel: 'tipo_proceso', export: true, table: false,
        },
        usuario: {
            header: 'Usuario', value: '', required: false, optionLabel: 'tipo_ejecucion', export: true, table: false,
            filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        solo_admin: {
            header: 'Admin', value: {nombre: 'SI', cat_id: true}, required: 'Seleccione una opción.', optionLabel: 'nombre'
        },
    }

    optionLabel = 'nombre'
}
